<template>
  <div class="dropdown">
    <select v-if="showOperator" v-model="filter.operator" class="form-control form-control-sm">
      <option v-for="operator in operators" :value="operator.value">
        {{ operator.label }}
      </option>
    </select>
    <input
      v-if="displayValueInput"
      ref="searchInput"
      v-model="searchText"
      type="text"
      class="form-control form-control-sm"
      :placeholder="placeholder"
      data-toggle="dropdown"
      data-flip="false"
      @keydown.down.stop="highlightForward"
      @keydown.up.stop="highlightBack"
      @keypress.enter.exact.stop="highlightSelect"
      @keypress.shift.enter.stop="$emit('submit')"
    >
    <div v-if="displayValueInput" class="dropdown-menu" @click.stop ref="dropdown">
      <div class="text-right mt-n1">
        <b-button v-if="!allSelected" size="sm" variant="link" class="py-0 font-weight-semibold" @click="selectAll">
          Select All
        </b-button>
        <span v-if="!noneSelected && !allSelected" class="mx-n1">|</span>
        <b-button v-if="!noneSelected" size="sm" variant="link" class="py-0 font-weight-semibold" @click="deselectAll">
          Deselect All
        </b-button>
      </div>
      <label
        v-for="(option, idx) in filteredOptions"
        :key="option.value"
        class="dropdown-item d-block"
        :class="{'highlight': highlightIndex == idx}"
      >
        <input v-model="filter.value" type="checkbox" :value="option.value"> {{ option.label }}
      </label>
    </div>
  </div>
</template>
<script>
  import { operators } from './dropdown';

  export default {
    props: {
      options: {
        type: Array,
        required: true,
      },
      showOperator: {
        type: Boolean,
        default: true
      },
      filter: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        operators,
        searchText: '',
        highlightIndex: 0,
      };
    },
    computed: {
      displayValueInput() {
        return this.filter.operator !== 'isNull';
      },
      normalizedOptions() {
        // If any options are a String rather than value/label, convert
        return this.options.map(option => {
          if (typeof option === 'string') {
            return {
              value: option,
              label: option,
            };
          }
          return option;
        });
      },
      filteredOptions() {
        if (this.searchText) {
          return this.normalizedOptions.filter(option => option.label.toLowerCase().startsWith(this.searchText.toLowerCase()));
        }
        return this.normalizedOptions;
      },
      noneSelected() {
        return this.filter.value.length === 0;
      },
      allSelected() {
        return this.filter.value.length === this.options.length;
      },
      placeholder() {
        if (this.filter.value.length > 0) {
          return `${this.filter.value.length} selected`;
        } else {
          return 'Type to filter...';
        }
      }
    },
    beforeMount() {
      if (!this.filter.value) {
        this.filter.value = [];
      }
      if (!this.filter.operator) {
        this.filter.operator = operators[0].value;
      }
    },
    mounted() {
      setTimeout(() => {
        $(this.$refs.searchInput).dropdown('toggle');
      }, 10);
    },
    watch: {
      'filter.value'(newVal) {
        if (newVal.length === this.normalizedOptions.length) {
          this.filter.allSelected = true;
        } else if (this.filter.allSelected) {
          this.filter.allSelected = false;
        }
      }
    },
    methods: {
      selectAll() {
        this.filter.value = this.normalizedOptions.map(o => o.value);
        this.filter.allSelected = true;
      },
      deselectAll() {
        this.filter.value = [];
        this.filter.allSelected = false;
      },
      highlightForward() {
        if (this.highlightIndex >= this.filteredOptions.length - 1) {
          this.highlightIndex = 0;
        } else {
          this.highlightIndex++
        }
        this.scrollToCurrentCheckbox();
      },
      highlightBack() {
        if (this.highlightIndex <= 0) {
          this.highlightIndex = this.filteredOptions.length - 1;
        } else {
          this.highlightIndex--;
        }
        this.scrollToCurrentCheckbox();
      },
      scrollToCurrentCheckbox() {
        const checkboxes = this.$refs.dropdown.querySelectorAll('input[type=checkbox]');
        checkboxes[this.highlightIndex].scrollIntoView({block: 'nearest'});
      },
      highlightSelect() {
        const checkboxes = this.$refs.dropdown.querySelectorAll('input[type=checkbox]');
        const highlighted = checkboxes[this.highlightIndex];
        if (highlighted.checked) {
          const idx = this.filter.value.indexOf(highlighted.value);
          this.filter.value.splice(idx, 1);
        } else {
          this.filter.value.push(highlighted.value);
        }
      }
    }
  };
</script>
<style scoped>
  select {
    width: 100px;
  }
  .dropdown-menu {
    max-height: 60vh;
    overflow-y: scroll;
  }
  .dropdown-item.highlight {
    color: #16181b;
    text-decoration: none;
    background-color: #e9ecef;
  }
</style>
